import React from 'react';
export const ComponentWrapper = ({ component: Component, }) => {
    if (typeof Component === 'function') {
        return React.createElement(Component, null);
    }
    if (typeof Component === 'object') {
        return React.createElement(React.Fragment, null, Component);
    }
    return React.createElement(React.Fragment, null);
};
//# sourceMappingURL=ComponentWrapper.js.map